export default __webpack_public_path__ + "static/media/ebay.34a4076b.svg";